// BUG: §azz// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import VueParallaxJs from 'vue-parallax-js'
import Chart from 'chart.js'
import VueChartKick from 'vue-chartkick'
import { firebase } from '@/firebase'
import VueTyperPlugin from 'vue-typer'
import i18n from './i18n'


window.mapboxgl = require('mapbox-gl');

Vue.use(VueTyperPlugin)
Vue.use(VueRouter)
Vue.use(VueParallaxJs)
Vue.use(VueChartKick, { adapter: Chart })

Vue.config.productionTip = false

let app

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      i18n,
      el: '#app',
      render: h => h(App),
      components: { App },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js